import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { DashboardSkeleton } from './Skeleton';

export default function ProtectedRoute({ children, role, requireSubscription }) {
  const { user, hasActiveLicense, isPaused, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="app-body" style={{ maxWidth: 1160, margin: '0 auto' }}>
        <DashboardSkeleton />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (role && user.role !== role) return <Navigate to={user.role === 'admin' ? '/admin' : '/dashboard'} replace />;
  // Admin'ler abonelik olmadan da dashboard'ı görebilir (destek/inceleme amaçlı).
  // Duraklı abonelik: lisanslar askıda ama kullanıcı devam ettirmek için panele girebilmeli.
  if (requireSubscription && !hasActiveLicense && !isPaused && user.role !== 'admin') return <Navigate to="/checkout" replace />;
  return children;
}
